import { createContext, useContext } from 'react';

/**
 * Where the footer MainLayout draws along the bottom of the screen (the nav plate and anything
 * pinned above it) starts, as a window y from `measureInWindow`, or null before it is measured.
 * A screen that scrolls to the bottom compares it with its own `measureInWindow` box to finish its
 * content just above the nav. Both numbers come from the same call, so they agree on every
 * platform - an Android window and the viewport height do not share an origin.
 */
export const FooterTopContext = createContext<number | null>(null);

export const useFooterTop = () => useContext(FooterTopContext);
